// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-list-content[data-v-70485aa0]{position:relative}.home-list-content .course-resource[data-v-70485aa0]{background:rgba(60,122,225,.1);padding-bottom:40px}.home-list-content .course-item[data-v-70485aa0]{z-index:2}.item-list[data-v-70485aa0]{background:#fff}", ""]);
// Exports
module.exports = exports;
